document.addEventListener('DOMContentLoaded', function() {
    'use strict';
    const header = document.querySelector('.header');
    const isSticky = document.querySelector('.is_sticky');
    const mainLogo = document.querySelector('.main_url');
    const stickyLogo = document.querySelector('.sticky_url');

    function handleScroll() {
        const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scroll >= 100) {
            isSticky.classList.add('sticky');
            isSticky.style.width = '100%';
            isSticky.style.padding = '0px 10px';
        } else {
            isSticky.classList.remove('sticky');
       
        }
    }
    window.addEventListener('scroll', handleScroll);
});
